import type { GroupBase } from 'react-select';

import type { RCreatableProps } from './react-creatable';
import { CreatableSelect } from './react-creatable';

import { FormItem, FormMessage } from '../form';

export function FormCreatableSelect<
  Option,
  IsMulti extends boolean = false,
  Group extends GroupBase<Option> = GroupBase<Option>,
>({ formItemClassName, ...props }: RCreatableProps<Option, IsMulti, Group> & { formItemClassName?: string }) {
  return (
    <FormItem className={formItemClassName}>
      <CreatableSelect {...props} />
      <FormMessage />
    </FormItem>
  );
}
